import { langToLocale, messages } from '@/app/i18n/constants';
import { LocaleContext } from '@/app/i18n/context';
import { getInitialLocale, setLocaleCookie } from '@/app/i18n/utils';
import { PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { IntlProvider } from 'use-intl';

export function IntlWrapper({ children }: PropsWithChildren) {
  const [locale, setLocaleState] = useState(getInitialLocale);

  const setLocale = useCallback((newLocale: string) => {
    // Convert short code to full locale if needed
    const fullLocale = langToLocale[newLocale] || newLocale;
    setLocaleState(fullLocale);
    setLocaleCookie(fullLocale);
  }, []);

  const contextValue = useMemo(
    () => ({
      locale,
      setLocale,
    }),
    [locale, setLocale],
  );

  const currentMessages = messages[locale] || messages['en-US'];

  return (
    <LocaleContext.Provider value={contextValue}>
      <IntlProvider messages={currentMessages} locale={locale}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
}
